import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randUuid } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import type { RawPostcodeLookupResponse } from '@/models/address.js'

export type UKPostcodeLookupData = SchemaAttributes<'UKPostcodeLookup'>

export const model = Model as ModelDefinition<UKPostcodeLookupData>

export const factory = Factory.extend<UKPostcodeLookupData>({
  postcode() {
    return 'SW1A 1AA'
  },
  task_id() {
    return randUuid()
  },
})

export function routes(server: MockServer) {
  server.post(
    '/postcodes/uk_lookup',
    function (this: MirageServer, schema, request) {
      const { data } = JSON.parse(request.requestBody)
      const { postcode } = data.attributes

      const fixedData: RawPostcodeLookupResponse = {
        result: [1, 2, 3].map((n) => ({
          line_1: `${n} High Street`,
          line_2: '',
          line_3: '',
          post_town: 'Sample Town',
          dependant_locality: '',
          county: '',
        })),
      }

      return {
        data: {
          type: 'UKPostcodeLookup',
          attributes: {
            postcode,
            data: null,
            raw_data: fixedData,
          },
        },
      }
    },
  )
}
